<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <h1 v-translate>Měny</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr>
          <th class="no_padding drag_drop" />
          <th class="no_padding checkbox" />
          <sorting-table-title
              v-for="title in tableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit" />
        </tr>
        </thead>

        <currencies-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            @input="select"
            :selectedEntities="selectedEntities"
            :ref="'vod-videos-row-ref-'+entity.id"
        ></currencies-row>

        <tr v-if="entities.length === 0">
          <td colspan="5">{{ $gettext('Nebyly nalezeny žádné měny.') }}</td>
        </tr>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import CurrenciesRow from "./CurrenciesRow.vue";
import listActions from "@/components/mixins/list-actions"

export default {
  name: "Currencies",
  components: {
    CurrenciesRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'currencies',
      entitiesKey: 'currencies',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
    }
  },
  created(CurrencyService) {
    this.entityService = CurrencyService;

    this.createdInit();
  },
  computed: {
    tableTitles() {
      return [
          {key: 1, name: this.$gettext('Název'), column: 'sName'},
          {key: 2, name: this.$gettext('Jednotka'), column: 'sSymbol'},
          {key: 3, name: this.$gettext('Formátování'), column: 'sFormatString'}
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/currencies/CurrenciesList.vue